module.exports = __webpack_public_path__ + "static/media/three.ac6a41a5.svg";